export const FEEDBACK_SUCCESS = 'PROJECTS_SUCCESS';
export const GET_FEEDBACKS = 'GET_FEEDBACKS';
export const GET_QUERIES = 'GET_QUERIES';
export const GET_TICKETS_FALLOWUP = 'GET_TICKETS_FALLOWUP';
export const SELECTED_SITE_ID = 'SELECTED_SITE_ID';
export const GET_TICKETS_FALLOWUP_COUNT = 'GET_TICKETS_FALLOWUP_COUNT';